<template>
  <v-container>
    <div class="text-h4">Will your PBX control the outpulsing of caller ID number?</div>
    <v-radio-group
      :value="getProductInfo().pbx_control"
      @change="setPBXControlAnswer"
    >
      <v-radio label="Yes" value="y"></v-radio>
      <v-radio label="No" value="n"></v-radio>
      <v-radio label="Unknown" value="unknown"></v-radio>
    </v-radio-group>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'PBXControl',
  methods: {
    ...mapActions(['updateStoreFormData', 'updateNewNumbersField']),
    setPBXControlAnswer(newVal) {
      const vm = this;
      vm.updateStoreFormData({
        data: newVal,
        main: vm.getProductIdSelected,
        sub: 'pbx_control',
      });
    },
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo']),
  },
};
</script>
